import theme from '../../../lib/theme';
import { LightStoryProps } from './LightStory';

const {
  colors,
  layouts,
  font: {
    families,
    heights,
    spacings,

    ...font
  },
} = theme;
export default ({ vane = false }: LightStoryProps) => ({
  link: {
    textDecoration: 'none !important',
    
    '&:hover *': {
      //  override hover underline
      textDecoration: 'none !important',
      color: colors.sas.primary,
    },

    '&:hover h2': {
      textDecoration: 'underline !important',
    },
  },

  category: {
    color: colors.sas.primary,
    fontFamily: families.primary,
    fontWeight: '500',
    textDecoration: 'none',
    fontSize: font.xs,
    textTransform: 'capitalize',

    '&:hover': {
      color: `${colors.sas.primary} !important`,
      textDecoration: 'underline',
    },
  },

  title: {
    color: colors.black,
    fontSize: vane ? font.xl : font.l,
    fontFamily: families.primary,
    fontWeight: `500`,
    lineHeight: vane ? heights.xl : heights.l,
    transition: 'all 150ms linear',
    maxWidth: 550,
    margin: `0 !important`,
  },

  byline: {
    color: colors.dark_grey,
    fontSize: font.xs,
    fontFamily: families.primary,
    fontWeight: font.normal,
    lineHeight: heights.s,
    margin: `0 !important`,
  },

  bylineAuthor: {
    color: colors.black,
  },

  contentBlock: {
    ...layouts.spacedColumn('xxs'),

    alignItems: 'stretch',
  },

  container: {
    ...layouts.spacedColumn('xxxxs'),

    alignItems: 'flex-start',
    width: '100%',
  },
});
